module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-christmas-left-582441a19a417e4d65f75dff240ec403.svg";